/** 
* @description 认证模块 
* @version 0.3.7 
* @author lengyingxin <lengyingxin8966@gmail.com> (https://github.com/LengYXin)
*/
var env = {
  version: "0.3.7",
  timestamp: "2023-01-06 12:05"
};

export { env as default };
//# sourceMappingURL=env.js.map
